/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { Temporal } from 'temporal-polyfill'

import { type Move, type UpdateMovePayload } from '../../../../modules/moves'
import { type DateTimeFormValues } from './DateTimeForm.type'

export const moveToFormData = (move: Move): DateTimeFormValues => {
  return {
    jobs: move.jobs.map(job => {
      const plainDate = Temporal.PlainDate.from(job.dateTime.startDate)
      const zonedDateTime = plainDate.toZonedDateTime({
        plainTime: Temporal.PlainTime.from('00:00:00'),
        timeZone: job.resolved?.timeZone ?? Temporal.Now.timeZoneId(),
      })
      const moveDateTime = new Date(zonedDateTime.epochMilliseconds)

      return {
        id: job.id,
        dateTime: {
          startDate: moveDateTime,
          preferredTimeRanges: job.dateTime.preferredTimeRanges ?? [],
        },
      }
    }),
  }
}

export const formatFormOutput = (values: DateTimeFormValues): UpdateMovePayload => {
  return {
    jobs: values.jobs.map(job => {
      const startDate = job.dateTime.startDate.toISOString().substring(0, 10)

      return {
        ...job,
        dateTime: {
          startDate,
          preferredTimeRanges: job.dateTime.preferredTimeRanges ?? [],
        },
      }
    }),
  }
}
